import Button from '@/components/Button';
import { MasterTranslation, TextStyles } from '@/constants';
import { useGlobalState, useResponsive } from '@/hooks';
import { ButtonSize, ButtonVariant, ResponsiveCollection } from '@/interfaces';
import {
  AccountSectionArrow,
  AccountSectionSubText,
  AccountSectionTitle,
  AccountSectionTitleWrapper,
  AccountSectionWrapper,
} from '../Account.styles';

interface AccountSectionProps {
  title: string;
  subText?: string;
  icon: React.ReactNode;
  children?: React.ReactNode;
  hasArrow?: boolean;
  onClick?: () => void;
  showCTAButton?: boolean;
}

const AccountSection: React.FC<AccountSectionProps> = ({
  title,
  subText,
  icon,
  children,
  hasArrow,
  onClick,
  showCTAButton = true,
}) => {
  const { t, isLoggedIn, setShowPMTPopUp, setIsFromEmailSyncBtn } = useGlobalState();
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);

  const handleClickJoinUs = () => {
    setShowPMTPopUp(true);
    setIsFromEmailSyncBtn(true);
  };

  return (
    <AccountSectionWrapper isLoggedIn={isLoggedIn} onClick={onClick}>
      {/* Left column */}
      <div>
        <AccountSectionTitleWrapper>
          {icon}
          <AccountSectionTitle variant={isDesktopPMT ? TextStyles['Heading 2'] : TextStyles['Heading 4']}>
            {title}
          </AccountSectionTitle>
          {hasArrow && <AccountSectionArrow />}
        </AccountSectionTitleWrapper>

        {subText && <AccountSectionSubText variant={TextStyles['Body Text Small']}>{subText}</AccountSectionSubText>}
      </div>

      {/* Right column */}
      {isLoggedIn
        ? children
        : showCTAButton && (
            <Button truncate={1} size={ButtonSize.Medium} variant={ButtonVariant.Outlined} onClick={handleClickJoinUs}>
              {t(MasterTranslation.AccJoinUsCta)}
            </Button>
          )}
    </AccountSectionWrapper>
  );
};

export default AccountSection;
